import { render, staticRenderFns } from "./WelcomeHeaderInfoForm.vue?vue&type=template&id=15fbdd40&scoped=true&"
import script from "./WelcomeHeaderInfoForm.vue?vue&type=script&lang=js&"
export * from "./WelcomeHeaderInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeHeaderInfoForm.vue?vue&type=style&index=0&id=15fbdd40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbdd40",
  null
  
)

export default component.exports